<section class="main">
  <div class="heading d-flex justify-content-between align-items-center">
    <h1>General access</h1>
    <div>
      <button class="btn" (click)="addcategory()">Create new category</button>
      <button class="btn add" (click)="addMmber()">Add new member</button>
    </div>
  </div>
  <div class="edit_view mb-4 mt-2">
    <button class="btn activeBtn">
      View/Edit
    </button>
  </div>

  <div class="d-flex justify-content-between ">
    <div class="d-flex filter">
      <input class="form-control" type="text" placeholder="Search clients" />
      <div class="dropdown mb-0 ">
        <button class="btn  dropdown-toggle text-truncate" type="button" id="dropdownMenuButton1"
          data-bs-toggle="dropdown" aria-expanded="false">
          {{ All_categories }}
          <img src="assets/images/mangeunit/arrow.png" />
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li *ngFor="let item of global_categroy">
            <a class="dropdown-item" style="cursor: pointer" (click)="filter_staff(item)">{{ item }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="sup_filter">
      <div class="dropdown mb-0 ">
        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
          aria-expanded="false">
          {{ selectparent }}
          <img src="assets/images/mangeunit/arrow.png" />
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li>
            <a class="dropdown-item" style="cursor: pointer" (click)="getParent('Staff')">Staff</a>
          </li>
          <li>
            <a class="dropdown-item" style="cursor: pointer" (click)="getParent('VIP')">VIP</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div id="cardPrint">
    <div class="cards print" *ngFor="let item of dataPrint">
      <div class="front" style="text-align: center">
        <div>
          <h4 [ngClass]="{'onwers': item.status == true , 'nonOwners': item.status == false }">
            {{ item.type | uppercase }}</h4>
          <img [src]="item.image" alt="Avatar" />
          <hr [ngClass]="{'onwers': item.status , 'nonOwners': !item.status }" />
          <div class="containerr">
            <h1>{{ item.name | uppercase }}</h1>
            <!-- <p>Unit : {{ item.unitName }}</p>
              <p>Zone : {{ item.villageName }}</p> -->
          </div>
        </div>
      </div>
      <div class="back">
        <div>
          <img [src]="item.image1" />
        </div>
      </div>
    </div>
  </div>

  <button id="printButton" class="cardPrint" [useExistingCss]="true" printSectionId="cardPrint" ngxPrint>
    print
  </button>

  <!-- cards -->
  <section class="cards_content mt-5">
    <div class="row">
      <div class="col-md-4 col-12" *ngFor="let item of globaly_array">
        <div class="clientsCard"   [ngClass]="{
          clientsCardWhenBlock: item.cancelled === true
        }">
          <div class="row info">
            <div class="col-4">
              <img class="user img-fluid" src="assets/images/avatar.png" />
            </div>
            <div class="col-7 p-0 ownerInfo">
              <p class="mb-2 text-truncate">
                <img *ngIf="item.verified" src="assets/images/mangeunit/circle_check.png" />
                {{ item.name }}
              </p>
              <div>
                <span class="hint" *ngIf="item.verified">
                  Authenticated
                </span>
                <span class="hint">
                  {{ item.type.name }}
                </span>
                <span class="hint" *ngIf="item.activated == true">
                  Active
                </span>
                <span class="hint" *ngIf="item.activated == false">
                  unActive
                </span>
              </div>
            </div>
            <div class="col-1 dots">
              <mat-menu #menu="matMenu">
                <p (click)="editClient(item.id)" class="menuItem" mat-menu-item>Edit</p>
                <p *ngIf="item.cancelled === false" (click)="openBlockClient('block', item)" class="menuItem"
                  mat-menu-item>
                  Block
                </p>
                <p *ngIf="item.cancelled === true" (click)="openBlockClient('unblock', item)" class="menuItem"
                  mat-menu-item>
                  Active
                </p>
                <p (click)="openDeletClient(item)" class="menuItem" mat-menu-item>
                  Delete
                </p>
              </mat-menu>
              <img [matMenuTriggerFor]="menu" src="assets/images/mangeunit/dots.png" />
            </div>
          </div>

          <div class="mt-4 icons d-flex align-items-center justify-content-between">
            <!-- <img  matTooltip="Invitations " matTooltipClass="example-tooltip-uppercase"
              [matTooltipPosition]="'above'" src="assets/images/mangeunit/Group 162.png" /> -->

            <img mat-raised-button matTooltip="Gate access" (click)="blockUnitGates(item.id)"
              matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'" class="icon2"
              src="assets/images/mangeunit/Group 136.png" />

            <img mat-raised-button matTooltip="Activate" (click)="addCard(item)"
              matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'" class="icon3"
              src="assets/images/mangeunit/Group 160.png" />

            <div class="notes">
              <p *ngIf="item.notes.length != 0">
                <span>{{ item.notes.length}}</span>
              </p>
              <img mat-raised-button matTooltip="Add/Show Note" (click)="addNote('client', item.id)"
                matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'"
                src="assets/images/mangeunit/Group 170.png" />
            </div>

            <img mat-raised-button matTooltip="Print" (click)="print_card(item)"
              matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'"
              src="assets/images/mangeunit/5.png" />
          </div>
        </div>
      </div>
    </div>

    <p *ngIf="massage_display">No data Found</p>
  </section>

</section>


<!-- model blocked -->

<button
  id="btn4"
  style="display: none"
  type="button"
  class="btn btn-primary"
  data-bs-toggle="modal"
  data-bs-target="#exampleModal4"
>
  Launch demo modal
</button>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal4"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title" id="exampleModalLabel">
          {{ blockClientTitle }} client
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        Are you sure you want to {{ blockClientTitle }} the client?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="blockClient()"
          data-bs-dismiss="modal"
        >
          {{ blockClientTitle }} Client
        </button>
      </div>
    </div>
  </div>
</div>


<!-- delete model -->

<button
  id="btn3"
  style="display: none"
  type="button"
  class="btn btn-primary"
  data-bs-toggle="modal"
  data-bs-target="#exampleModal3"
>
  Launch demo modal
</button>

<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal3"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title" id="exampleModalLabel">Delet client</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        Are you sure you want to delet the client?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="DeleleClient()"
          data-bs-dismiss="modal"
        >
          Delet client
        </button>
      </div>
    </div>
  </div>
</div>